import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { wkidSet, wkidSelector } from 'redux/keyFieldsSlice';

import { StyledSpatialReferenceHelperText } from './SpatialReference-styled';

import ReactSelectWrapper, {
  SelectOption
} from 'components/ReactSelectWrapper';

import { GroupBase, MenuListProps, SingleValue } from 'react-select';
import { FixedSizeList } from 'react-window';

import spatialReferences from './spatialreferences.json';
import { CalciteLink } from 'components/Calcite';

const options = spatialReferences.wkids.map(sr => {
  const stringifiedWkid = String(sr.value);
  return {
    value: stringifiedWkid,
    label: sr.label,
    subtitle: stringifiedWkid
  };
});

const SpatialReference: React.FC = () => {
  const dispatch = useDispatch();

  const wkid = useSelector(wkidSelector);

  const components = useMemo(
    () => ({
      MenuList: (
        props: MenuListProps<SelectOption, false, GroupBase<SelectOption>>
      ) => {
        const childrenArray = React.Children.toArray(props.children);
        return (
          <FixedSizeList
            height={300}
            itemCount={childrenArray.length}
            itemData={childrenArray}
            itemSize={32}
            width={500}
          >
            {({ data, index, style }) => <div style={style}>{data[index]}</div>}
          </FixedSizeList>
        );
      }
    }),
    []
  );

  const onSelect = (newValue: SingleValue<SelectOption>) => {
    if (newValue?.value && newValue.value !== '') {
      dispatch(wkidSet(Number(newValue.value)));
    }
  };

  return (
    <>
      <ReactSelectWrapper
        components={components}
        containerStyles={{ width: '500px' }}
        isMulti={false}
        isSearchable
        onChange={onSelect}
        options={options}
        placeholder="Enter a spatial reference system"
        selectedValue={wkid ? String(wkid) : ''}
      />
      <StyledSpatialReferenceHelperText>
        <CalciteLink
          target="_blank"
          href="https://developers.arcgis.com/rest/services-reference/enterprise/using-spatial-references.htm"
        >
          Additional information on Projected and Geographic coordinate systems
        </CalciteLink>
      </StyledSpatialReferenceHelperText>
    </>
  );
};

export default SpatialReference;
